var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7344 1.59144C11.6668 3.06915 12.0362 6.16666 10.5159 8.80949C8.99555 11.4523 6.11117 12.6743 3.88039 11.7365C3.29783 11.4949 2.77211 11.225 2.16113 10.8698L5.14497 5.71198L8.12881 0.554199C8.73979 0.895209 9.2371 1.22201 9.7344 1.59144Z",
    fill: "url(#paint0_linear_594_2526)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86228 2.18899C11.5105 3.43936 11.8657 6.13902 10.6296 8.45505C9.47864 10.6148 7.33312 11.7231 5.5144 11.2258C4.36349 11.5384 3.18416 11.4531 2.16113 10.8705C2.77211 11.2258 3.29783 11.4815 3.88039 11.7373C6.11117 12.6751 8.99555 11.4531 10.5159 8.81027C12.0362 6.16744 11.6668 3.06993 9.7344 1.60643C9.2371 1.22279 8.754 0.89599 8.14302 0.540771C8.754 0.89599 9.2371 1.3933 9.59231 1.97586C9.67757 2.0469 9.77703 2.11794 9.86228 2.18899Z",
    fill: "url(#paint1_radial_594_2526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47126 0.778894C10.6594 2.04347 11.1425 5.31149 9.55113 8.06799C7.95974 10.8245 4.89065 12.0464 2.7025 10.7819C0.514354 9.51728 0.0170479 6.24927 1.60843 3.47856C3.19981 0.722059 6.2689 -0.485686 8.47126 0.778894Z",
    fill: "#FCCE3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12983 0.540847C10.4459 1.87647 10.9858 5.27236 9.33758 8.12832C7.68936 10.9843 4.47818 12.2062 2.16215 10.8706C-0.153874 9.53499 -0.693807 6.1391 0.954409 3.28314C2.60263 0.427177 5.8138 -0.794776 8.12983 0.540847Z",
    fill: "url(#paint2_radial_594_2526)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74538 9.87728C5.71696 10.0052 5.58908 10.1188 5.43279 10.1615C5.2907 10.2041 5.14861 10.1757 5.06336 10.1046C4.36713 10.2609 3.6709 10.2183 3.03151 9.91991C1.19858 9.06738 0.60181 6.45297 1.69588 4.09431C2.29265 2.80132 3.28727 1.84933 4.35292 1.39465C4.36713 1.23835 4.49501 1.09627 4.67972 1.05364C4.85023 1.01101 5.02073 1.05364 5.1202 1.16731C5.36174 1.12468 5.6175 1.09627 5.85905 1.09627C5.91589 1.01101 6.02956 0.968387 6.15743 0.996805C6.2569 1.02522 6.34215 1.08206 6.37057 1.16731C6.59791 1.20994 6.81104 1.28098 7.02417 1.38044C8.8571 2.23297 9.45387 4.84738 8.35979 7.22024C7.76302 8.47061 6.79683 9.40839 5.74538 9.87728Z",
    fill: "#FFFCE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33221 1.59417C9.06567 2.58878 9.42089 5.2174 8.14211 7.43397C6.86332 9.66474 4.4052 10.6594 2.68594 9.66474C0.952473 8.67013 0.597254 6.04151 1.87604 3.82494C3.15483 1.59417 5.59874 0.599554 7.33221 1.59417Z",
    fill: "url(#paint3_radial_594_2526)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81515 4.70512C4.03711 2.60222 6.35314 1.65024 7.98714 2.60222C8.22869 2.74431 8.42762 2.90061 8.61233 3.09953C8.35657 2.46013 7.9161 1.94862 7.33354 1.60761C5.60007 0.612997 3.15617 1.60761 1.86317 3.82418C0.584379 6.04074 0.953807 8.65515 2.68728 9.66397C2.81515 9.73502 2.94303 9.79185 3.07091 9.84869C1.89159 8.7262 1.73529 6.56647 2.81515 4.70512Z",
    fill: "url(#paint4_radial_594_2526)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44573 4.14937C3.62505 2.1033 5.77058 1.09448 7.46142 1.70546C7.51825 1.71967 7.57509 1.74809 7.61772 1.76229C7.57509 1.73388 7.53246 1.69125 7.47563 1.66283C7.433 1.63442 7.39038 1.606 7.33354 1.57758C5.60007 0.582967 3.15616 1.57758 1.86317 3.79415C0.584379 6.03913 0.953807 8.65354 2.68728 9.66236C2.7299 9.69078 2.78674 9.7192 2.82936 9.73341C2.8862 9.76183 2.92882 9.79024 2.98566 9.80445C2.94303 9.77603 2.90041 9.73341 2.85778 9.70499C1.46532 8.55408 1.2664 6.18122 2.44573 4.14937Z",
    fill: "url(#paint5_linear_594_2526)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24057 1.53495C6.65262 1.50654 7.06467 1.56337 7.44831 1.70546C7.50515 1.71967 7.56198 1.74809 7.60461 1.76229C7.56198 1.73388 7.51935 1.69125 7.46252 1.66283C7.41989 1.63442 7.37727 1.606 7.32043 1.57758C5.58696 0.582967 3.14306 1.57758 1.85006 3.79415C0.58548 6.03913 0.954907 8.65354 2.68838 9.66236C2.731 9.69078 2.78784 9.7192 2.83046 9.73341C2.8873 9.76183 2.92993 9.79024 2.98676 9.80445C2.94413 9.77603 2.90151 9.73341 2.85888 9.70499C2.64575 9.53449 2.46104 9.32135 2.30474 9.09401C1.02595 8.02836 0.81282 5.81179 1.87848 3.90782C2.8873 2.07489 4.72023 1.13711 6.24057 1.53495Z",
    fill: "url(#paint6_radial_594_2526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_2526",
    x1: 4.8499,
    y1: 12.4201,
    x2: 10.8137,
    y2: 2.09053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#F8941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_594_2526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.09627 5.14316) scale(8.12772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6543,
    stopColor: "#E4D9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#B3984C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_594_2526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.01083 0.329776) scale(10.4223 10.4223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_594_2526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0106275 -0.701457) scale(12.735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68A1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_594_2526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.11294 6.59785) scale(7.3574 7.35739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6694,
    stopColor: "#FFE1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA74F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_594_2526",
    x1: 1.25587,
    y1: 8.83597,
    x2: 5.84213,
    y2: 0.892334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_594_2526",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.2448 6.90706) scale(7.13248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6543,
    stopColor: "#E4D9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#B3984C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCoin);
export default __webpack_public_path__ + "static/media/bigCoin.98a13840319cc4bb2d71461e60442249.svg";
export { ForwardRef as ReactComponent };